export const GED_CONSTANTS = {
  resizeMaxWidth: 3000, // Resize max width (px)
  resizeMaxHeight: 3000, // Resize max height (px)
  resizeQuality: 0.6, // Resize quality (0 to 1)
  isResizeEnabled: true, // Is resize enabled
};
